import router from '@/router'
import store from '@/store'
const adminid_arr=[
  3,
  338,
  280,
  992,

]
router.beforeEach((to ,from,next)=>{
    console.log('store.state.Token.token',store.state.Token.token)
  if(to.matched.some(ele=>ele.meta&&ele.meta.isLogin)){
    if(store.state.Token.token){
        if(Object.keys(store.state.User.userinfo).length<1){
            store.dispatch('User/getUserInfo').then((res) => {
            console.log('获取用户信息成功，放行',res)
            if (adminid_arr.includes(res.userid)) {
               next()
            } else {
              next('/login')
            }
           
    
            }).catch((err) => {
                
                console.log('获取用户信息失败，跳转登录',err)
                next('/login')
            })
        }else{
             console.log('已登录,直接放行')
             next()
        }
        
     
    }else{
        console.log('认证路由,TOKEN为空,先登陆')
        next('/login')
    }
    
  }else{
    console.log('非认证路由，直接放行')
    next()
  }
})